module.exports = __webpack_public_path__ + "static/media/Lato-Italic.0acac383.eot";